(function () {
  function ready() {
    document.querySelectorAll('[data-mm-course-buy]').forEach(mount);
  }

  function dateLabel(row) {
    const start = new Date(row.starts_on + 'T12:00:00');
    const end = new Date(row.ends_on + 'T12:00:00');
    const startDay = start.getDate();
    const endDay = end.getDate();
    const month = new Intl.DateTimeFormat('en-AU', { month: 'short' }).format(end);
    const year = end.getFullYear();
    const sameMonth = start.getMonth() === end.getMonth();
    const range = sameMonth
      ? startDay + '-' + endDay + ' ' + month + ' ' + year
      : row.starts_on + ' to ' + row.ends_on;
    const place = row.city === 'sydney' ? 'Sydney' : 'Melbourne';
    return range + ' · ' + place;
  }

  function mount(root) {
    const proxy = (root.getAttribute('data-mm-course-proxy') || '').replace(/\/$/, '');
    const durationEl = root.querySelector('[data-mm-course-duration]');
    const cityEl = root.querySelector('[data-mm-course-city]');
    const cohortEl = root.querySelector('[data-mm-course-cohort]');
    const openEl = root.querySelector('[data-mm-course-open]');
    const variantEl = root.querySelector('[data-mm-course-variant]');
    const priceEl = root.querySelector('[data-mm-course-price]');
    const twoId = root.getAttribute('data-two-id');
    const threeId = root.getAttribute('data-three-id');
    const twoPrice = root.getAttribute('data-two-price') || '';
    const threePrice = root.getAttribute('data-three-price') || '';
    const fallback = root.getAttribute('data-mm-course-fallback') || '';
    const params = new URLSearchParams(window.location.search);
    const DATE_CAP = 3;
    let cohorts = [];
    let showLater = false;

    if (params.get('duration') === '3' && durationEl) durationEl.value = '3';
    if (params.get('city') && cityEl) {
      const city = params.get('city').toLowerCase();
      if (city === 'melbourne' || city === 'sydney') cityEl.value = city;
    }
    setVariant();
    setPrice();

    function useRows(rows) {
      cohorts = rows || [];
      if (params.get('cohort')) {
        const wanted = params.get('cohort');
        const row = cohorts.find(function (item) {
          return item.id === wanted;
        });
        if (row) {
          durationEl.value = String(row.duration_days);
          if (cityEl) cityEl.value = row.city;
          setVariant();
          setPrice();
        }
      }
      fill();
      if (params.get('cohort')) {
        cohortEl.value = params.get('cohort');
        applyCohort();
      }
    }

    fetch(proxy + '/course-slots', { credentials: 'omit' })
      .then(function (res) {
        return res.json();
      })
      .then(function (payload) {
        if (!payload || !payload.ok) throw new Error('no slots');
        useRows(payload.cohorts);
      })
      .catch(function () {
        if (!fallback) {
          cohortEl.innerHTML = '<option value="">Dates did not load. Call 1800 240 410.</option>';
          return;
        }
        fetch(fallback, { credentials: 'omit' })
          .then(function (res) {
            return res.json();
          })
          .then(function (pack) {
            const today = new Date().toISOString().slice(0, 10);
            const seats = Number((pack && pack.seats) || 6);
            useRows(
              ((pack && pack.cohorts) || [])
                .filter(function (row) {
                  return row.starts_on >= today;
                })
                .map(function (row) {
                  return {
                    id: row.id,
                    slug: row.slug,
                    city: row.city,
                    duration_days: row.duration_days,
                    starts_on: row.starts_on,
                    ends_on: row.ends_on,
                    seats: seats,
                    seats_left: seats,
                    status: 'open'
                  };
                })
            );
          })
          .catch(function () {
            cohortEl.innerHTML = '<option value="">Dates did not load. Call 1800 240 410.</option>';
          });
      });

    durationEl.addEventListener('change', function () {
      showLater = false;
      setVariant();
      setPrice();
      fill();
    });
    if (cityEl) {
      cityEl.addEventListener('change', function () {
        showLater = false;
        fill();
      });
    }
    cohortEl.addEventListener('change', function () {
      if (cohortEl.value === '__later__') {
        showLater = true;
        fill();
        return;
      }
      applyCohort();
    });
    if (openEl) openEl.addEventListener('change', applyOpen);

    function setVariant() {
      variantEl.value = durationEl.value === '3' ? threeId || twoId : twoId;
    }

    function setPrice() {
      if (!priceEl) return;
      priceEl.textContent = durationEl.value === '3' ? threePrice : twoPrice;
    }

    function matching() {
      const days = Number(durationEl.value);
      const city = cityEl ? cityEl.value : 'all';
      return cohorts
        .filter(function (row) {
          if (Number(row.duration_days) !== days) return false;
          if (city !== 'all' && row.city !== city) return false;
          return true;
        })
        .sort(function (a, b) {
          return a.starts_on < b.starts_on ? -1 : 1;
        });
    }

    function fill() {
      const rows = matching();
      const visible = showLater ? rows : rows.slice(0, DATE_CAP);
      const previous = cohortEl.value;
      cohortEl.innerHTML = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = rows.length ? 'Select a date' : 'No dates for this course and city';
      cohortEl.appendChild(placeholder);
      visible.forEach(function (row) {
        const opt = document.createElement('option');
        opt.value = row.id;
        opt.textContent = dateLabel(row) + (row.status === 'open' ? '' : ' (full)');
        opt.disabled = row.status !== 'open';
        opt.dataset.slug = row.slug;
        opt.dataset.city = row.city;
        opt.dataset.starts = row.starts_on;
        opt.dataset.ends = row.ends_on;
        cohortEl.appendChild(opt);
      });
      if (!showLater && rows.length > DATE_CAP) {
        const later = document.createElement('option');
        later.value = '__later__';
        later.textContent = 'Later dates';
        cohortEl.appendChild(later);
      }
      const openOpt = document.createElement('option');
      openOpt.value = 'open';
      openOpt.textContent = 'Open seat, place me later';
      cohortEl.appendChild(openOpt);
      if (previous && previous !== '__later__') {
        const still = Array.prototype.some.call(cohortEl.options, function (opt) {
          return opt.value === previous;
        });
        if (still) cohortEl.value = previous;
      }
      applyCohort();
    }

    function setProp(name, value) {
      const input = root.querySelector('[data-prop="' + name + '"]');
      if (input) input.value = value || '';
    }

    function applyCohort() {
      const value = cohortEl.value;
      if (value === '__later__') return;
      if (value === 'open' || !value) {
        setProp('cohort_id', '');
        setProp('cal_slug', '');
        setProp('city', '');
        setProp('starts_on', '');
        setProp('ends_on', '');
        setProp('placement', value === 'open' ? 'open' : '');
        if (openEl) openEl.checked = value === 'open';
        return;
      }
      const opt = cohortEl.selectedOptions[0];
      setProp('cohort_id', value);
      setProp('cal_slug', opt.dataset.slug);
      setProp('city', opt.dataset.city);
      setProp('starts_on', opt.dataset.starts);
      setProp('ends_on', opt.dataset.ends);
      setProp('placement', '');
      if (openEl) openEl.checked = false;
    }

    function applyOpen() {
      if (openEl.checked) {
        cohortEl.value = 'open';
        applyCohort();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
